<template>
  <div class="initialSettings">
    <div class="con">
      <div class="top-title">初始参数设置</div>
      <div class="set-right">
        <div class="right-item">
          <div class="item-top">
            <span>缴费方式选择</span>
          </div>
          <div class="add-input">
            <p>新增缴费方式</p>
            <div class="caozuo">
              <span>名称：</span>
              <el-input v-model="paymentName" style="width:240px;margin-right:20px"></el-input>
              <el-button type="primary" @click="add_fn">保存添加</el-button>
            </div>
          </div>
          <div class="inp">
            <p class="inp-title">选择缴费方式</p>
            <div class="mycheckgroud">
              <el-checkbox-group v-model="wayData">
                <span class="item-check" v-for="item in wayList" :key="item.id"><el-checkbox :label="item.paymentName"
                    @change='checkChange($event,item,0)'></el-checkbox> <i class="el-icon-delete"
                    @click="del_fn(item,0)"></i></span>
              </el-checkbox-group>
            </div>

          </div>
        </div>

        <div class="right-item">
          <div class="item-top">
            <span>表类型选择</span>
          </div>
          <div class="add-input">
            <p>新增表类型</p>
            <div class="caozuo">
              <span>名称：</span>
              <el-input v-model="typeName" style="width:240px;margin-right:20px"></el-input>
              <el-button type="primary" @click="edit_fn">保存添加</el-button>
            </div>
          </div>
          <div class="inp">
            <p class="inp-title">选择缴费方式</p>
            <div class="mycheckgroud">
              <el-checkbox-group v-model="typeData">
                <span class="item-check" v-for="item in typeList" :key="item.id"><el-checkbox :label="item.typeName"
                    @change='checkChange($event,item,1)'></el-checkbox> <i class="el-icon-delete"
                    @click="del_fn(item,1)"></i></span>
              </el-checkbox-group>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {findMethods,savePayment,deletePayment,findMeterType,saveMeterType,deleteMeterType} from "../../api/zhongshanMeter";
  export default {

    data () {
      return {
        wayList: [],//缴费方式选择
        wayData: [],//缴费方式选择
        typeList: [],//表类型选择
        typeData: [],//表类型选择

        paymentName: "",//缴费方式
        typeName: '',//表类型


      };
    },

    mounted () {
      this.getWayList() //获取缴费方式
      this.getTypeList() //获取表类型方式
    },

    methods: {
      //获取缴费方式
      getWayList () {
        findMethods().then(res => {
          if(res.code==200) {
            this.wayList=res.data
            this.wayData=[]
            res.data.forEach(item => {
              if(item.state==1) {
                this.wayData.push(item.paymentName)
              }
            })
          }
        })
      },
      //获取表类型方式
      getTypeList () {
        findMeterType().then(res => {
          if(res.code==200) {
            this.typeList=res.data
            this.typeData=[]
            res.data.forEach(item => {
              if(item.state==1) {
                this.typeData.push(item.typeName)
              }
            })
          }
        })
      },

      //确定添加缴费方式
      add_fn () {
        if(this.paymentName=="") {
          this.$message({showClose: true,message: '名称不能为空',type: 'warning'});
          return
        }
        var d={
          'paymentName': this.paymentName,
        }
        savePayment(d).then(res => {
          if(res.code==200) {
            this.getWayList();

            this.$message({showClose: true,message: '添加缴费方式成功',type: 'success'});
            this.paymentName=""
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加缴费方式失败');
          }
        })
      },

      //确定添加表类型
      edit_fn () {
        if(this.typeName=="") {
          this.$message({showClose: true,message: '名称不能为空',type: 'warning'});
          return
        }
        var d={
          'typeName': this.typeName,
        }
        saveMeterType(d).then(res => {
          if(res.code==200) {
            this.getTypeList();
            this.$message({showClose: true,message: '添加表类型成功',type: 'success'});
            this.typeName=""
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加表类型失败');
          }
        })
      },
      //删除 type 为0是缴费方式，为1是表类型
      del_fn (val,type) {
        this.$confirm(`是否删除${type==0? '缴费方式':'表类型'}中的 ${type==0? val.paymentName:val.typeName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //缴费方式
          if(type==0) {
            deletePayment({"id": val.id}).then(res => {
              if(res.code==200) {
                this.$message({showClose: true,message: '删除成功',type: 'success'});
                this.getWayList();
              } else {
                res.message? this.$message.error(res.message):this.$message.error('删除失败');

              }
            })

          } else { //表类型
            deleteMeterType({"id": val.id}).then(res => {
              if(res.code==200) {
                this.$message({showClose: true,message: '删除成功',type: 'success'});
                this.getTypeList();
              } else {
                res.message? this.$message.error(res.message):this.$message.error('删除失败');

              }
            })

          }

        }).catch(() => {
          // ...
        });

      },
      //表类型
      checkChange (val,item,type) {
        if(type==0) {
          savePayment({'id': item.id}).then(res => {
            if(res.code==200) {
              this.getWayList();
              this.$message({showClose: true,message: `更改缴费方式中的 ${item.paymentName} 状态成功`,type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error(`更改缴费方式中的 ${item.paymentName} 状态失败`);
            }
          })
        } else {
          saveMeterType({'id': item.id}).then(res => {
            if(res.code==200) {
              this.getTypeList();
              this.$message({showClose: true,message: `更改表类型中的 ${item.typeName} 状态成功`,type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error(`更改表类型中的 ${item.typeName} 状态失败`);
            }


          })
        }

      },

    },
  };
</script>

<style lang="scss" scoped>
  .initialSettings {

    display: flex;
  }

  .con {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
  }

  .top-title {
    font-size: 16px;
    border-bottom: 2px solid #E6E6E6;
    padding-bottom: 15px;
  }

  .set-right {
    .right-item {
      margin-top: 20px;
      height: 340px;
      border: 1px solid #E6E6E6;

      .item-top {
        color: #fff;
        display: flex;
        align-items: center;
        height: 44px;
        background-color: #368ED9;

        span {
          font-size: 16px;
          margin-left: 20px;
        }
      }

      .add-input {
        height: 77px;
        padding: 20px;
        border-bottom: 1px solid #E6E6E6;
        color: #1A1A1A;

        p {
          font-size: 16px;
        }

        span {
          color: #1A1A1A;

          &::before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
          }
        }

        .caozuo {
          margin-top: 20px;
          display: flex;
          align-items: center;

        }
      }

      .inp {
        margin-top: 15px;
        width: 97%;
        //  display: flex;
        //  align-items: center;
        //  justify-content: space-between;

        .inp-title {
          font-size: 16px;
          color: #1A1A1A;
          margin: 20px;
        }

        .mycheckgroud {
          margin: 0px 20px;
        }

        /deep/.el-checkbox-group {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }

        /deep/.el-checkbox__input {
          position: relative;
          top: -1px;
          margin-left: 12px;
        }

        /deep/.el-checkbox__label {
          color: #1A1A1A;
          padding-left: 5px;
        }

      }

      .add-btns {
        width: 36px;
        height: 36px;
        background-color: #52A1FF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;

        i {
          font-size: 22px;
        }
      }

      .item-check {
        display: inline-block;
        width: 2.4rem;
        height: 44px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        i {
          margin-left: 12px;
          cursor: pointer;
          display: none;
          font-size: 20px;
          color: #999999;
        }

        &:hover i {
          display: block;
        }
      }
    }



  }
</style>